import {
  CALCULATOR_FORMULA_IMPORT_SCENARIO,
  CALCULATOR_GENERAL_SCENARIO,
} from '@/types/calculatorFormula';
import { getUserSessionScopeSuffix } from '@/utils/userSessionScope';

/** 后端 scenario 列最长 255 字符（页面上下文场景键） */
const SCENARIO_MAX_LEN = 255;

export interface CalcFormulaSessionMeta {
  formulaId: string;
  formulaName: string;
  shortDesc?: string;
  description?: string;
  systemPrompt?: string;
  welcomeMessage?: string;
}

const CALC_META_PREFIX = 'aipd_calc_meta_';

export function calcScenarioForFormulaId(formulaId: string): string {
  const direct = `calculator_${formulaId}`;
  if (direct.length <= SCENARIO_MAX_LEN) return direct;
  let h = 5381;
  for (let i = 0; i < formulaId.length; i++) {
    h = ((h << 5) + h + formulaId.charCodeAt(i)) >>> 0;
  }
  const short = `calc_${h.toString(36).slice(0, 10)}`;
  return short.length <= SCENARIO_MAX_LEN ? short : short.slice(0, SCENARIO_MAX_LEN);
}

export function calcSessionTitle(formulaName: string): string {
  const name = (formulaName || '自定义公式').trim();
  return `${name}-计算`;
}

export function importArchiveTitle(source: 'excel_import' | 'manual', label: string): string {
  const text = (label || '').trim() || '公式';
  return source === 'excel_import' ? `Excel导入-${text}` : `${text}-创建`;
}

export function isCalculatorCalcScenario(scenario: string): boolean {
  if (!scenario) return false;
  if (scenario === CALCULATOR_FORMULA_IMPORT_SCENARIO || scenario === CALCULATOR_GENERAL_SCENARIO) {
    return false;
  }
  return scenario.startsWith('calculator_') || scenario.startsWith('calc_');
}

export function buildCalcSessionPrefix(meta: CalcFormulaSessionMeta): string {
  const lines = [`【${meta.formulaName} · 计算助手】`];
  if (meta.shortDesc?.trim()) lines.push(`简介：${meta.shortDesc.trim()}`);
  if (meta.description?.trim()) lines.push(`说明：${meta.description.trim()}`);
  if (meta.systemPrompt?.trim()) lines.push(`计算指引：${meta.systemPrompt.trim()}`);
  lines.push('请根据用户填写的参数协助完成计算、验算与答疑。');
  return lines.join('\n');
}

export function saveCalcSessionMeta(scenario: string, meta: CalcFormulaSessionMeta): void {
  try {
    localStorage.setItem(`${CALC_META_PREFIX}${getUserSessionScopeSuffix()}_${scenario}`, JSON.stringify(meta));
  } catch {
    /* ignore */
  }
}

export function loadCalcSessionMeta(scenario: string): CalcFormulaSessionMeta | null {
  try {
    const raw = localStorage.getItem(`${CALC_META_PREFIX}${getUserSessionScopeSuffix()}_${scenario}`);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as CalcFormulaSessionMeta;
    if (!parsed?.formulaId || !parsed?.formulaName) return null;
    return parsed;
  } catch {
    return null;
  }
}
